import React from 'react';

const ENTRIES_OPTIONS = [5, 10, 20, 50];

/**
 * Reusable toolbar for admin list pages: search, sort A-Z/Z-A, entries per page.
 * Controlled: searchInput, search, sort, limit; callbacks: onSearch, onClear, onSortChange, onLimitChange.
 * onSearch(searchInput) and onClear() should typically also reset page to 1; the parent does that.
 */
const AdminListToolbar = ({
  searchInput,
  onSearchInputChange,
  search,
  onSearch,
  onClear,
  sort,
  onSortChange,
  limit,
  onLimitChange,
  searchPlaceholder = 'Search...',
  sortLabel = 'Sort:',
  sortOptions = [
    { value: 'a-z', label: 'A to Z' },
    { value: 'z-a', label: 'Z to A' }
  ],
  entriesLabel = 'Entries per page:',
  showEntries = true,
  showSearch = true
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      {showSearch && (
      <div className="flex flex-1 flex-wrap gap-2">
        <input
          type="text"
          value={searchInput}
          onChange={(e) => onSearchInputChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
          placeholder={searchPlaceholder}
          className="flex-1 min-w-[200px] px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
        <button
          onClick={onSearch}
          className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-sm font-medium"
        >
          Search
        </button>
        {(searchInput || search) && (
          <button
            onClick={onClear}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm font-medium"
          >
            Clear
          </button>
        )}
      </div>
      )}
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">{sortLabel}</label>
          <select
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm"
          >
            {sortOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        {showEntries && (
          <div className="flex items-center gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">{entriesLabel}</label>
            <select
              value={limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm"
            >
              {ENTRIES_OPTIONS.map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminListToolbar;
export { ENTRIES_OPTIONS };
